import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-bootstrap';
import { inject, PropTypes as MobxPropTypes, PropTypes } from 'mobx-react'

import Dropzone from 'react-dropzone'
import { DoubleBounce } from 'better-react-spinkit'

import Editor, { createEditorStateWithText } from 'draft-js-plugins-editor';
import createLinkPlugin from 'draft-js-anchor-plugin';
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin';
import { ItalicButton, BoldButton, UnderlineButton } from 'draft-js-buttons';
import { stateToHTML } from 'draft-js-export-html';
import { ContentState, EditorState, RichUtils, convertToRaw } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';

import config from 'react-global-configuration';
import 'draft-js-inline-toolbar-plugin/lib/plugin.css';

import { BlackHeading } from '../../GeneralStyle'
import { ProfileBox } from '../ProfileStyle'
import { Input, EditorInput, DropzoneDiv } from './BlackboardStyle'
import axios from 'axios'

import pictureIcon from '../../../images/icons/picture.png'
import { LogeButtonSlim } from '../Residence/ActiveResidenceBookingsStyle';

const linkPlugin = createLinkPlugin();
const inlineToolbarPlugin = createInlineToolbarPlugin({
  structure: [
    BoldButton,
    ItalicButton,
    UnderlineButton,
    linkPlugin.LinkButton
  ]
});
const { InlineToolbar } = inlineToolbarPlugin;
const plugins = [inlineToolbarPlugin, linkPlugin];

const text = 'Hier kann der Text des Angebots geschrieben werden. Wenn Sie einen Teil des Texts markieren, können Sie verschiedene Effekte anwenden oder einen Link hinzufügen...';

@inject('blogStore')
class BlogPostEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accepted: [],
      rejected: [],
      blogImage: this.props.editPost ? this.props.blogPost.imageId : null,
      blogText: this.props.editPost ? this.props.blogPost.blogText : null,
      blogTitle: this.props.editPost ? this.props.blogPost.blogTitle : null,
      editorState: EditorState.createWithContent(stateFromHTML(this.props.editPost ? this.props.blogPost.text : text)), //createEditorStateWithText(text)/* : createEditorStateWithText(text)*/,
      imageUploading: false,
      imageUploaded: false,
      value: this.props.editPost ? this.props.blogPost.title : null
    }
    this.baseState = this.state
    this.onEditorChange = this.onEditorChange.bind(this)
    this.focus = this.focus.bind(this)
    this.uploadWidget = this.uploadWidget.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.saveBlog = this.saveBlog.bind(this)
    this.updateBlog = this.updateBlog.bind(this)
    this.onTitleChange = this.onTitleChange.bind(this)
    this.resetComponent = this.resetComponent.bind(this)
  }

  uploadWidget(file) {
    let formData = new FormData()

    formData.append('file', file[0])
    formData.append("tags", `theloge, blog`)
    formData.append("upload_preset", config.get("CLOUDINARY_PRESET"))
    formData.append("timestamp", (Date.now() / 1000) | 0)

    axios.post(config.get("CLOUDINARY_UPLOAD_URL"), formData, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then(response => {
      this.setState({
        blogImage: response.data.public_id,
        imageUploaded: true,
        imageUploading: false
      })
    }).catch(err => {
      console.error("err", err)
    })
  }

  onDrop(acceptedFiles) {
    this.setState({
      imageUploading: true,
      image: acceptedFiles[0]
    });
    this.uploadWidget(acceptedFiles)
  }

  onEditorChange = (editorState) => {
    this.setState({
      editorState: editorState,
      blogText: '<style>.blogpost > p{color:black;} .blogpost > p > a{text-decoration: underline; color:#337AB8;}</style><div class="blogpost">' + stateToHTML(editorState.getCurrentContent()) + '</div>'

    });
  };

  onTitleChange = (evt) => {
    this.setState({
      blogTitle: evt.target.value,
      value: event.target.value
    })
  }

  focus = () => {
    this.editor.focus()
  };

  resetComponent = () => {
    this.setState(this.baseState)
    this.setState({ value: "" })
  }

  deleteBlogPost = () => {
    this.props.blogStore.deleteBlogPost(this.props.blogPost.objectId)

    this.props.cancelEdit()
  }

  updateBlog = () => {
    if ((this.state.blogTitle && this.state.blogText && this.state.blogImage) !== null) {
      this.props.blogStore.editBlogPost({
        blogImage: this.state.blogImage,
        blogTitle: this.state.blogTitle,
        blogText: this.state.blogText,
        objectId: this.props.blogPost.objectId
      })

      this.resetComponent()

      this.props.cancelEdit()

    } else {
      console.error("fill in required attribtues")
      console.log("this.state.blogTitle", this.state.blogTitle)
      console.log("this.state.blogText", this.state.blogText)
      console.log("this.state.blogImage", this.state.blogImage)
    }
  }

  saveBlog = (blogPost) => {
    if ((this.state.blogTitle && this.state.blogText && this.state.blogImage) !== null) {
      this.props.blogStore.saveBlogPost({
        blogImage: this.state.blogImage,
        blogTitle: this.state.blogTitle,
        blogText: this.state.blogText,
        blogCategory: this.props.blogCategory
      })

      this.resetComponent()
    } else {
      console.error("fill in required attribtues")
      console.log("this.state.blogTitle", this.state.blogTitle)
      console.log("this.state.blogText", this.state.blogText)
      console.log("this.state.blogImage", this.state.blogImage)
    }
  };


  render() {
    const loadingSpinner = (
      <div style={{ margin: "0px auto", marginTop: 65, width: 60 }}>
        <DoubleBounce color={"#DAB777"} size={60} />
      </div>)

    let deleteButton = (
      <LogeButtonSlim
        style={{ backgroundColor: 'rgb(217, 83, 79)', border: "none" }}
        hoverFontColor={"white"}
        fontColor={"white"}
        onClick={() => { this.deleteBlogPost() }}>
        Beitrag entfernen</LogeButtonSlim>
    )

    return (
      <Grid>
        <Row style={{ paddingBottom: 45 }}>
          {this.props.editPost ? <div style={{ width: "100%", borderTop: "1px solid rgba(0, 0, 0, 0.15)", marginTop: 65 }}></div> : ''}
          <BlackHeading style={{ textAlign: "left", paddingTop: 45 }}>{this.props.editPost ? "Beitrag bearbeiten" : "Neuen Beitrag verfassen"}</BlackHeading>
          <ProfileBox style={{ border: '0px solid white' }}>
            <Col sm={12} md={3}>
              <div style={{ margin: "10 auto", width: 200 }}>
                <Dropzone
                  multiple={false}
                  accept="image/*"
                  onDrop={this.onDrop}>
                  {this.state.imageUploading ? loadingSpinner : this.state.imageUploaded ? null : <DropzoneDiv size={64} image={this.props.editPost ? 'https://res.cloudinary.com/theloge/image/upload/' + this.props.blogPost.imageId : pictureIcon} />}
                  {this.state.imageUploading ? null : this.state.imageUploaded ? <DropzoneDiv size={128} image={this.state.image.preview} /> : ''}
                </Dropzone>
              </div>
            </Col>
            <Col sm={12} md={9}>
              <Input
                onChange={this.onTitleChange}
                placeholder={'Titel des Beitrags'}
                value={this.state.value}
              />
              <EditorInput
                onClick={this.focus}>
                <Editor
                  editorState={this.state.editorState}
                  onChange={this.onEditorChange}
                  plugins={plugins}
                  ref={(element) => { this.editor = element; }}
                />
                <InlineToolbar />
              </EditorInput>
            </Col>
            <Row><div style={{ float: "right", margin: 10 }}>
              {this.props.editPost
                ?
                deleteButton
                : ''}
              {this.props.editPost
                ?
                <LogeButtonSlim
                  hoverFontColor={"white"}
                  onClick={() => { this.props.cancelEdit() }}>
                  Bearbeiten abbrechen</LogeButtonSlim>
                : ''}
              <LogeButtonSlim
                hoverFontColor={"white"}
                onClick={() => { this.props.editPost ? this.updateBlog() : this.saveBlog() }}>
                {this.props.editPost ? 'Beitrag speichern' : 'Beitrag veröffentlichen'}</LogeButtonSlim>
            </div>

            </Row>

          </ProfileBox>
        </Row>
      </Grid >
    )
  }
}
BlogPostEditor.propTypes = {
  blogStore: MobxPropTypes.observableObject,
  editPost: PropTypes.bool,
  blogPost: PropTypes.object,
};
export default BlogPostEditor



// WEBPACK FOOTER //
// /src/components/internal/BlackboardBlog/BlogPostEditor.js